import { css } from '@emotion/css'
import { mikePalette } from '@mike/mike-shared-frontend/mike-shared-styles/mikeSharedTheme'
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'

export const StyledIconButton = styled(Button)(({ theme }) => ({
  color: theme.palette.secondary.main,
  '&:disabled': {
    color: theme.palette.secondary.light
  }
}))

export const StyledButtonSecondaryBorder = styled(Button)({
  padding: 0,
  paddingRight: 12,
  minWidth: 160,
  border: '2px solid ' + mikePalette.secondary.main,
  backgroundColor: mikePalette.lightGrey.main,
  color: mikePalette.secondary.main,
  '&[disabled]': {
    color: mikePalette.secondary.light,
    opacity: 0.5,
    cursor: 'not-allowed'
  }
})

export const StyledButtonSecondaryBorderWhite = styled(Button)({
  padding: 0,
  paddingRight: 12,
  border: '2px solid ' + mikePalette.secondary.main,
  color: mikePalette.text.primary,
  '&[disabled]': {
    color: mikePalette.secondary.light,
    opacity: 0.5,
    cursor: 'not-allowed'
  }
})

export const iconButtonStyle = css`
  button {
    color: ${mikePalette.secondary.main};
  }
`

export const iconStyle = css`
  path {
    fill: ${mikePalette.secondary.main};
  }
`

export const iconPrimaryStyle = (disabled = false) => {
  const color = disabled ? mikePalette.primary.light : mikePalette.primary.main
  return css`
    path {
      fill: ${color};
    }
  `
}

export const iconSecondaryStyle = (disabled = false) => {
  const color = disabled
    ? mikePalette.secondary.light
    : mikePalette.secondary.main
  return css`
    path {
      fill: ${color};
    }
  `
}

export const iconCustomSizeStyle = (size = 32) => {
  const height = size
  return css`
    svg {
      height: ${height};
      width: ${height};
    }
  `
}
